export default "__VITE_ASSET__Dw6YBDdo__"